<script setup lang="ts">
import ExternalAssociations from './components/ExternalAssociations.vue';
import UserLocation from './components/UserLocation.vue';
import StudentInfo from './components/StudentInfo.vue';
import StudentReferrals from './components/StudentReferrals.vue';
import UserGeneral from './components/UserGeneral.vue';
import MedicaidBilling from './components/MedicaidBilling.vue';
import ZoomClassroom from '@/components/Forms/User/ZoomLinkForm/ZoomClassroom.vue';
import { PersonStores } from '@/store';
import { computed } from 'vue';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';
import { can, usePersonTypes, useTenant } from '@/composables';

const profileStore = PersonStores.useUserProfileStore();
const $tenant = useTenant();

const medicaidEnabled = computed(() => $tenant.tenantSettingEnabled(TENANT_SETTINGS.MEDICAID_BILLING));

/**
 * computed property to load StudentInfo if the user is a student
 */
const isStudent = computed(() => usePersonTypes.isStudent(profileStore.person?.people_type?.acronym));

const isClinician = computed(() => usePersonTypes.isClinician(profileStore.person?.people_type?.acronym));
</script>

<template>
  <UserGeneral class="page-content-half" />
  <UserLocation class="page-content-half" />
  <ExternalAssociations
    v-if="can([PERMISSIONS.PEOPLE_INDEX_STUDENT_EXTERNAL_ASSOCIATIONS, PERMISSIONS.PEOPLE_INDEX_EXTERNAL_ASSOCIATIONS])"
    class="page-content-half"
  />
  <ZoomClassroom v-if="isClinician" :loading="profileStore.loading" />
  <MedicaidBilling v-if="isClinician && medicaidEnabled" :loading="profileStore.loading" class="page-content-full" />
  <StudentInfo v-if="isStudent && can([PERMISSIONS.PEOPLE_INDEX_STUDENT])" class="page-content-half" />
  <StudentReferrals v-if="isStudent && can([PERMISSIONS.PEOPLE_INDEX_STUDENT])" />
</template>
